import { CollectionsListState } from '@src/types/Collection';
import { CollectionView } from 'common';

export function getVisibleCollectionsByCategory(
  collectionsList: CollectionsListState,
  filteredCollections: CollectionView[]
): Map<string, CollectionView[]> {
  const filteredById = new Map<string, CollectionView>();
  filteredCollections.forEach((collection) => filteredById.set(collection._id, collection));

  const map = new Map<string, CollectionView[]>();
  collectionsList.forEach((category) => {
    const visible = category.list
      .map((collectionId) => filteredById.get(collectionId))
      .filter((collection): collection is CollectionView => Boolean(collection));
    map.set(category.name, visible);
  });

  return map;
}
